export const ExistingCustomerFinalResponse = (state) => {
    const { uniqueId, existingCustomerAPIRes, productType, productFormData, deliveryAddressData } = state;

    // Map values from productFormData to existingCustomerAPIRes
    existingCustomerAPIRes['T_FullName'] = productFormData?.fullName ? productFormData.fullName : '';
    existingCustomerAPIRes['T_MSISDN'] = productFormData?.prefix && productFormData?.mobileNumber ? productFormData.prefix + productFormData.mobileNumber : '';
    existingCustomerAPIRes['Z_Address_City'] = deliveryAddressData?.city;
    existingCustomerAPIRes['Z_Address_District'] = deliveryAddressData?.districtName;
    existingCustomerAPIRes['Z_Address_Street'] = deliveryAddressData?.streetName;
    existingCustomerAPIRes['Z_Address_Building'] = deliveryAddressData?.buildingNo;
    existingCustomerAPIRes['Z_Delivery_Note_Region'] = deliveryAddressData?.region;
    existingCustomerAPIRes['Z_DD_Comments'] = deliveryAddressData?.shortAddress;
    const apiProductType =
        state.productType === 'Fiber'
            ? 'Fixed_Internet'
            : state.productType;

    existingCustomerAPIRes['ZKUT_ProductSegment'] = apiProductType;


    let seq = 0;
    const productInformationData = state.productInformationData.length > 0 && state.productInformationData.map((item) => {
        seq = seq + 10;
        const mrc = item.productInformation.packageName?.mrc ? item.productInformation.packageName.mrc : '0'
        const nrc = item.productInformation.packageName?.nrc ? item.productInformation.packageName.nrc : '0'
        const quantity = item?.productInformation?.quantity?.value ? String(item.productInformation.quantity.value) : '1'
        const product = {
            ID: seq,
            ItemProduct: {
                ProductID: item.productInformation.packageName.product_Id,
                ProductTypeCode: "1",
            },
            Quantity: quantity,
            ZOrderType: item.productInformation.orderType?.value === "New Activation" ? "101" : "111",
            ZPackageMode: item.productInformation.packageName.mode_sfaId,
            ZPackageType: item.productInformation.packageName.packageType_sfaId,
            ZSIMType: item.productInformation.packageName.simType_sfa,
            GeoLatitude: item.productInformation.latitude?.value,
            GeoLongitude: item.productInformation.longitude?.value,
            NRC: nrc,
            MRC: mrc,
            TVC: String((parseFloat(mrc) * parseFloat(quantity)) + parseFloat(nrc)),
            ZProductDescription: item?.productInformation?.packageName?.name
        };

        return product;
    });

    existingCustomerAPIRes['Item'] = productInformationData;
    existingCustomerAPIRes['ID'] = state.randomID;
    if (['Fiber', 'SIP'].includes(productType)) {
        existingCustomerAPIRes['Z_ODBOperator'] = state.productInformationData[0].productInformation?.ODBOperator?.value
        existingCustomerAPIRes['ZODBNumber'] = state.productInformationData[0].productInformation?.ODBNumber?.value
        existingCustomerAPIRes['ZZExisitng_Flag'] = "1"
    }
    const topProductInfo = state.productInformationData[0].productInformation;
    if (productType === 'SIP' && (topProductInfo.installed !== 'yes' || topProductInfo.IPPBX !== 'yes' || topProductInfo.telephoneDevice !== 'yes' || topProductInfo.telecomEquipment !== 'yes')) {
        existingCustomerAPIRes['OriginTypeCode'] = 'Z07'
        existingCustomerAPIRes['ZDocumentType'] = 'Z104'
    }

    const ID = uniqueId.replaceAll(/-/g, "").toUpperCase();
    const UUID = uniqueId;

    const finalResponse = {
        "MOBILY_BSL_SR": {
            "SR_HEADER": {
                "FuncId": "CreateOpportunitySFA",
                "MsgVersion": "0001",
                "RequestorUserId": "ePortal",
                "RequestorChannelId": "ePortalUser",
                "ChannelTransactionId": `SR_${state.dateString}`,
                "SrDate": state.dateString
            },
            "OpportunityReq": {
                "Envelope": {
                    "Body": {
                        "LeanLeadReplicationBulkReplicateRequest": {
                            "MessageHeader": {
                                "ID": ID,
                                "UUID": UUID,
                                "CreationDateTime": state.createdTime, // system date
                                "ExistingCustomer": "Y", //This Flag is created for EAI identify between the existing and new customer as the input parameters are different in both cases.
                                "SenderBusinessSystemID": "", //Static
                                "RecipientBusinessSystemID": "", //Static
                                "SenderParty": {
                                    "InternalID": "" //Static
                                },
                                "RecipientParty": {
                                    "InternalID": "" //Static
                                }
                            },
                            "LeanLeadReplicateRequestMessage": {
                                "MessageHeader": {
                                    "UUID": UUID
                                },
                                "LeanLead": existingCustomerAPIRes,
                            }
                        }
                    }
                }
            },
            "AttachmentReq": {
                "Envelope": {
                    "Header": "",
                    "Body": {
                        "AttachmentFolderBulkReplicateRequest": {
                            "MessageHeader": {
                                "ID": ID,
                                "UUID": UUID,
                                "CreationDateTime": state.createdTime,
                                "SenderBusinessSystemID": "", //Static
                                "RecipientBusinessSystemID": "", //Static
                                "SenderParty": {
                                    "InternalID": "" //Static
                                },
                                "RecipientParty": {
                                    "InternalID": "" //Static
                                }
                            },
                            "AttachmentFolderReplicateRequestMessage": {
                                "BasicMessageHeader": {
                                    "UUID": UUID
                                },
                                "AttachmentFolder": {
                                    "HostObjectReference": {
                                        "ObjectTypeCode": "", //Static
                                        "ObjectID": state.randomID //lead ID
                                    },
                                    "Document": state.downloadAttachmentData
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    return finalResponse;
}